import { Box, Divider, Flex, Grid, Text } from "@chakra-ui/react";
import CustomInput from "components/common/customInput/CustomInput";
import JsonFileUpload from "../component/JsonFileUpload";
import { useState } from "react";
import { generateLevels } from "../utils/function";

const DefineApproval = ({
  activePage,
  isDisabled,
  values,
  setFieldValue,
  approvalModalOptions,
  setInitialValues,
  initialValues,
  handleFileLoad,
}: any) => {
  const [uploadJSON, setUploadJSON] = useState<Boolean>(false);
  return (
    <Box display={activePage === 3 ? undefined : "none"}>
      {/* Define File Viewer */}

      <Box mt={3}>
        <Grid
          templateColumns={"1fr 1fr 1fr 1fr"}
          gap={6}
          justifyItems={"center"}
        >
          <CustomInput
            disabled={isDisabled}
            type="switch"
            name="fileViewer.show"
            label="Show Approval Modal"
            value={values.fileViewer.show}
            onChange={(e: any) =>
              setFieldValue(`fileViewer.show`, e.target.checked)
            }
          />
          {values?.fileViewer?.show && (
            <>
              <CustomInput
                type="select"
                label="Select Option"
                name={`fileViewer.approvalModalOption`}
                value={values.fileViewer.approvalModalOption}
                placeholder="Select Option"
                options={approvalModalOptions}
                onChange={(e: any) =>
                  setFieldValue(`fileViewer.approvalModalOption`, e)
                }
                disabled={isDisabled}
                rest={{
                  width: { base: "10rem", lg: "100%" },
                }}
                isBoxSelect={true}
              />
              <CustomInput
                disabled={isDisabled}
                type="switch"
                name="fileViewer.showValue"
                label="Show Values"
                value={values.fileViewer?.showValue}
                onChange={(e: any) =>
                  setFieldValue(`fileViewer.showValue`, e.target.checked)
                }
              />
              {values.fileViewer?.approvalModalOption?.value === "isFile" &&
                values.fileViewer?.showValue && (
                  <CustomInput
                    disabled={isDisabled}
                    type="switch"
                    name="fileViewer.editable"
                    label="Select Editable Mode"
                    value={values.fileViewer.editable}
                    onChange={(e: any) =>
                      setFieldValue(`fileViewer.editable`, e.target.checked)
                    }
                  />
                )}
              {values?.fileViewer?.approvalModalOption?.value === "isTable" && (
                <CustomInput
                  disabled={isDisabled}
                  type="switch"
                  name="fileViewer.tableFile"
                  label="Show File"
                  value={values.fileViewer.tableFile}
                  onChange={(e: any) =>
                    setFieldValue(`fileViewer.tableFile`, e.target.checked)
                  }
                />
              )}
              <CustomInput
                disabled={isDisabled}
                type="switch"
                name="fileViewer.showApprHistory"
                label="Show Approval History"
                value={values.fileViewer?.showApprHistory}
                onChange={(e: any) =>
                  setFieldValue(`fileViewer.showApprHistory`, e.target.checked)
                }
              />
              <CustomInput
                disabled={isDisabled}
                type="switch"
                name="reset_to_level_1"
                label="Reset to First Level on Rejection"
                value={values.reset_to_level_1}
                onChange={(e: any) =>
                  setFieldValue(`reset_to_level_1`, e.target.checked)
                }
              />
              <CustomInput
                type="select"
                name={`showAdditionalForm`}
                value={values.showAdditionalForm}
                options={generateLevels(values.levels)}
                label="Show Additional Form"
                placeholder="Select Level"
                onChange={(e: any) => setFieldValue(`showAdditionalForm`, e)}
                rest={{ minWidth: "220px" }}
                disabled={isDisabled}
                isBoxSelect
                isMulti
              />
              <CustomInput
                type="select"
                name={`fieldsToDisable`}
                value={values.fieldsToDisable}
                options={generateLevels(values.levels)}
                label="Can Edit Fields"
                placeholder="Select Level"
                onChange={(e: any) => setFieldValue(`fieldsToDisable`, e)}
                rest={{ minWidth: "220px" }}
                disabled={isDisabled}
                isBoxSelect
                isMulti
              />
              <CustomInput
                type="select"
                name={`withdrawalLevel`}
                value={values.withdrawalLevel}
                options={generateLevels(values.levels)}
                label="Show withdrawalLevel"
                placeholder="Select Level"
                onChange={(e: any) => setFieldValue(`withdrawalLevel`, e)}
                rest={{ minWidth: "220px" }}
                disabled={isDisabled}
                isBoxSelect
                isMulti
              />
              <CustomInput
                type="select"
                name={`withdrawalApproval`}
                value={values.withdrawalApproval}
                options={[{ label: 'approved', value: 'approved' }, { label: 'rejected', value: 'rejected' }]}
                label="Show withdrawalApproval"
                placeholder="Select Approval"
                onChange={(e: any) => setFieldValue(`withdrawalApproval`, e)}
                rest={{ minWidth: "220px" }}
                disabled={isDisabled}
                isBoxSelect
                isMulti
              />
              <CustomInput
                disabled={isDisabled}
                type="select"
                isMulti
                options={[
                  ...generateLevels(values.levels || 3),
                  // { label: "No Level", value: undefined },
                ]}
                label="Can Additional Document"
                value={values.canAdditionalDocument}
                name="canAdditionalDocument"
                onChange={(e: any) => setFieldValue(`canAdditionalDocument`, e)}
                isBoxSelect={true}
              />
              <CustomInput
                disabled={isDisabled}
                type="switch"
                name="forwardDocument"
                label="Forward Document"
                value={values.forwardDocument}
                onChange={(e: any) =>
                  setFieldValue(`forwardDocument`, e.target.checked)
                }
              />
              <CustomInput
                type="select"
                name={`forwardDocumentLevel`}
                value={values.forwardDocumentLevel}
                options={generateLevels(values.levels)}
                label="Forward Document Level"
                placeholder="Select Level"
                onChange={(e: any) => setFieldValue(`forwardDocumentLevel`, e)}
                rest={{ minWidth: "220px" }}
                disabled={isDisabled}
                isBoxSelect
                isMulti
              />
            </>
          )}
        </Grid>
      </Box>
      <Divider mt={4} borderColor={"gray.300"} />
      <Text mt={6} fontWeight="700" color={"teal"}>
        Define Bulk Filters Approval
      </Text>
      <Box mt={2}>
        <Grid templateColumns={{ md: "1fr 1fr 2fr" }} columnGap={5}>
          <CustomInput
            disabled={isDisabled}
            type="switch"
            label="Select Bulk Approve Mode"
            value={values.bulkApproveApproval}
            name="bulkApproveApproval"
            onChange={(e: any) =>
              setFieldValue(`bulkApproveApproval`, e.target.checked)
            }
          />
          <CustomInput
            disabled={isDisabled}
            type="switch"
            name="bulkRejectApproval"
            label="Select Bulk Reject Mode"
            value={values.bulkRejectApproval}
            onChange={(e: any) =>
              setFieldValue(`bulkRejectApproval`, e.target.checked)
            }
          />
        </Grid>
      </Box>

      <Divider mt={4} borderColor={"gray.300"} />
      <Flex gap={4} mt={6} alignItems="center">
        <Text whiteSpace="nowrap" fontWeight="700" color={"teal"}>
          Upload Schema JSON:
        </Text>
        <Box mt={-3}>
          <CustomInput
            disabled={isDisabled}
            type="switch"
            name="uploadJSON"
            value={uploadJSON}
            onChange={(e: any) => setUploadJSON(e.target.checked)}
          />
        </Box>
      </Flex>
      {uploadJSON && (
        <JsonFileUpload
          onFileLoad={handleFileLoad}
          setInitialValues={setInitialValues}
          initialValues={initialValues}
          values={values}
        />
      )}
    </Box>
  );
};

export default DefineApproval;
